import PageContainerMobile from 'components/PageContainer/layout/PageContainer.mobile'
import { RopTabs } from './components/RopTabs/RopTabs'
import { useRouteMatch } from 'react-router'
import { ropSubRoutes } from 'routes/desktopRoutes'
import { SubPrivateRoute } from 'routes/PrivateRoute'
import React from 'react'
import { Route, Switch } from 'react-router-dom'

const HomeRopMobile = () => {
  const { path, url } = useRouteMatch()
  return (
    <Switch>
      <Route exact path={path}>
        <PageContainerMobile>
          <RopTabs />
        </PageContainerMobile>
      </Route>
      {ropSubRoutes.map(route => (
        <SubPrivateRoute {...route} key={route.path} />
      ))}
    </Switch>
  )
}
export default HomeRopMobile
